import React, { useEffect, useState } from "react";
import ContainerPop from "../../Pops/ContainerPop";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { successToaster } from "../../../helper/toasterConfiguration";
import ButtonClose from "../../Pops/ButtonClose";
import { CircularProgress, TextField } from "@mui/material";
import { MdContactSupport } from "react-icons/md";
import { IoMdCloseCircleOutline } from "react-icons/io";

const ReplayModal = ({
  show,
  handleClose,
  selectedItem,
  setFiltersChanged,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [replay, setReplay] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async () => {
    if (!replay || replay?.length === 0) {
      setErrorMessage("you should add a replay");
      return;
    }

    setIsLoading(true);
    try {
      const { result, response, message } = await Helper.Put({
        url: `${api_Routes.Support.Replay}${selectedItem?.id}`,
        data: { replay },
      });
      if (response) {
        successToaster("Message was sent successfully");
        handleClose();
        setFiltersChanged(true);
      }
    } catch (error) {
      console.error("An error occurred during deletion:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedItem && show) {
      setReplay(selectedItem.replay || "");
    }
  }, [selectedItem, show]);

  return (
    <div
      className={`fixed inset-0 !z-50 ${
        show ? "visible" : "hidden"
      } bg-black bg-opacity-50 flex justify-center items-center`}
      onClick={handleClose}
    >
      <ContainerPop>
        <div
          aria-label="pop delete"
          className="swals-show flex justify-center relative box-border flex-col z-50 w-[32em] max-w-full p-4 border-0 rounded-sm bg-secondary dark:bg-darkPrimary text-darkTextColor dark:text-darkTextColor m-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div aria-label="header" className="text-[1rem]">
            <div
              className="close absolute top-6 right-4 z-50 !cursor-pointer text-textColor dark:text-darkTextColor"
              onClick={handleClose}
            >
              <IoMdCloseCircleOutline size={"1.3rem"} />{" "}
            </div>
            <div className="flex items-center justify-center w-[5em] h-[5em] mt-[1.25em] mx-auto mb-4 border-[.25em] border-[#facea8] text-[#facea8] rounded-full cursor-default">
              <div className="text-[3.75rem] leading-[5rem]">
                <MdContactSupport />
              </div>
            </div>
            <div className="relative flex justify-center items-center font-bold text-[#6c757d] text-3xl text-center mb-2">
              {selectedItem?.title}
            </div>
            <div className="block text-[#6c757d] mb-4 font-semibold">
              {selectedItem?.subject}
            </div>
            <TextField
              fullWidth
              variant="outlined"
              multiline
              label="Replay"
              rows={5}
              value={replay}
              onChange={(e) => {
                setReplay(e.target.value);
                setErrorMessage("");
              }}
              name="replay"
            />
            {errorMessage && (
              <div className="error text-red-600 text-start">
                *{errorMessage}
              </div>
            )}
            <div className="w-full mt-3 flex items-center justify-center flex-wrap">
              <button
                type="button"
                onClick={handleSubmit}
                disabled={isLoading}
                className="bg-primary m-1 py-2 px-8 font-medium text-[1.0625em] rounded-[0.25em] text-darkTextColor flex justify-center w-44"
              >
                {isLoading ? (
                  <CircularProgress size={24} sx={{ color: "white" }} />
                ) : (
                  "Replay"
                )}
              </button>
              <ButtonClose onClick={() => handleClose()} />
            </div>
          </div>
        </div>
      </ContainerPop>
    </div>
  );
};

export default ReplayModal;
